import { useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

// Free text and a select share one value. Suggestions come from the full scoped catalog.
export default function LocalityFilter({ value = '', options = [], onChange, label = 'Locality' }) {
  const [draft, setDraft] = useState(value);
  const timer = useRef(null);
  useEffect(() => { setDraft(value); clearTimeout(timer.current); }, [value]);
  useEffect(() => () => clearTimeout(timer.current), []);
  const choices = [...new Set([value, ...options].filter(Boolean))].sort((a, b) => a.localeCompare(b));
  const pick = next => { clearTimeout(timer.current); setDraft(next); onChange(next); };
  return <Form.Group style={{ minWidth: 220 }} className="mb-2">
    <Form.Label className="small mb-1">{label}</Form.Label>
    <Form.Control size="sm" type="search" aria-label={`Search ${label.toLowerCase()}`} placeholder="Type area, neighbourhood or city" value={draft} onChange={e => {
      const next = e.target.value; setDraft(next); clearTimeout(timer.current);
      timer.current = setTimeout(() => onChange(next.trim()), 300);
    }} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); pick(draft.trim()); } }} />
    <Form.Select className="mt-1" size="sm" aria-label={`${label} dropdown`} value={value} onChange={e => pick(e.target.value)}>
      <option value="">All localities</option>
      {choices.map(choice => <option key={choice} value={choice}>{choice}</option>)}
    </Form.Select>
    {(value || draft) && <Button size="sm" variant="link" className="p-0" onClick={() => pick('')}>Clear locality</Button>}
  </Form.Group>;
}
